import { AddressFormKeys } from 'components/AddressFormFields/constants'

export const BusinessAddressFormKeys = {
  ...AddressFormKeys,
} as const
